import { defaultIconColor } from '../constants';
import { SVGComponentPropsType } from 'assets/types';

export default ({ color = defaultIconColor, ...props }: Omit<SVGComponentPropsType, 'size'>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="41" height="22" {...props}>
    <defs>
      <filter id="a">
        <feColorMatrix
          in="SourceGraphic"
          values="0 0 0 0 0.615686 0 0 0 0 0.631373 0 0 0 0 0.666667 0 0 0 1.000000 0"
        />
      </filter>
    </defs>
    <g transform="translate(-343 -102)" fill="none" fillRule="evenodd">
      <g stroke={color} strokeWidth="2">
        <circle cx="3.81" cy="3.81" r="3.81" transform="translate(349.735 114.492)" />
        <circle cx="3.81" cy="3.81" r="3.81" transform="translate(369.714 114.492)" />
        <path d="M346.646 118.238a2.919 2.919 0 0 1-1.652-3.728l2.71-7.277h0a2.016 2.016 0 0 1 1.307-3.439l10.689-.63a24.31 24.31 0 0 1 5.56.312 8.203 8.203 0 0 1 4.654 2.543l.53.579a13.201 13.201 0 0 0 5.853 3.7l3.652 1.124a4 4 0 0 1 2.823 3.823v1.686a2.37 2.37 0 0 1-1.904 2.323h0-3.344M357.354 118.683l8.285.266" />
      </g>
    </g>
  </svg>
);
